const selectors = {
  content: '.infinite-marquee__content',
}

export class InfiniteMarquee extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.content = this.container.querySelector(selectors.content);
    
    this.clone = null;
    this.rafLoop = null;
    this.offsetX = 0;
    this.speed = parseInt(this.dataset.speed ?? '50');

    this.animate = this.animate.bind(this);
  }

  createClone() {
    const contentWidth = this.content.scrollWidth;
    const containerWidth = this.container.offsetWidth;

    if (!contentWidth || !containerWidth) {
      return;
    }

    if (!(contentWidth > containerWidth)) {
      const times = Math.round(containerWidth / contentWidth);
      
      for (let i = 0; i < times; i++) {
        const clone = this.content.cloneNode(true);
        this.content.innerHTML += clone.innerHTML;
      }
    }

    this.clone = this.content.cloneNode(true);
    this.clone.classList.remove('infinite-marquee__content');
    this.clone.classList.add('infinite-marquee__clone');
    this.content.appendChild(this.clone);
  }

  animate() {
    const rect = this.content.getBoundingClientRect();
    const cloneWidth = this.clone.clientWidth;
    const contentWidth = rect.width - cloneWidth;
    
    if (Math.abs(this.offsetX) >= contentWidth) {
      this.offsetX = 0;
    }
    
    this.offsetX -= (cloneWidth / (this.speed * 500));

    const progress = -1 * (this.offsetX / contentWidth);

    this.container.style.setProperty('--progress', progress);

    this.rafLoop = requestAnimationFrame(this.animate);
  }

  initialize() {
    if (!this.container || !this.content) {
      console.warn('InfiniteMarquee: container or content not found');
      return;
    }
    
    this.createClone();

    const speed = this.container.clientWidth / (this.speed * 0.15);
    

    this.container.style.setProperty('--speed', speed);

    // if (this.rafLoop) {
    //   cancelAnimationFrame(this.rafLoop);
    // }

    // this.rafLoop = requestAnimationFrame(this.animate);
  }

  connectedCallback() {
    this.initialize();
  }

  disconnectedCallback() {
    if (this.rafLoop) {
      cancelAnimationFrame(this.rafLoop);
    }
  }
}

if (!customElements.get('infinite-marquee')) {
  customElements.define('infinite-marquee', InfiniteMarquee);
}